module.exports = __webpack_public_path__ + "static/media/wedding-catering-8.eb6259f8.jpg";